// @flow

import React from 'react';
import LogoAmex from '_images/card-logos/logo-dark-amex.png';
import LogoMC from '_images/card-logos/logo-dark-mc.png';
import LogoVisa from '_images/card-logos/logo-dark-visa.png';
import './index.less';

const SupportCardLogos = (): React$Node => (
  <div className="support-card-logos">
    <img src={LogoVisa} alt="Visa Card" />
    <img src={LogoMC} alt="Master Card" />
    <img src={LogoAmex} alt="Amex Card" />
  </div>
);

export default SupportCardLogos;
